import React from 'react';
import { Link } from 'react-router-dom';

import { useDeps } from 'src/hooks/useDeps';

import { Svg } from '../Svg/Svg';

import classes from './FooterFeatures.scss';

export const FooterFeatures = React.memo(function FooterFeatures() {
    const { paths } = useDeps();
    return (
        <ul className={classes.footerControls}>
            <li>
                <Link
                    to={paths.community.joinCommunity}
                    className={[classes.footerFeature, classes.footerFeatureCommunity].join(' ')}
                >
                    <Svg name="community-icon" aria-hidden={true} />
                    <span className={classes.footerFeatureContent}>
                        Join our <br className="hidden-desktop" /> Community
                    </span>
                </Link>
            </li>
            <li>
                <Link
                    to={paths.storeLocator.storeLocator}
                    className={[classes.footerFeature, classes.footerFeatureContact].join(' ')}
                >
                    <Svg name="place" aria-hidden={true} />
                    <span className={classes.footerFeatureContent}>Stores</span>
                </Link>
            </li>
            <li>
                <Link to="/click-collect" className={[classes.footerFeature, classes.footerFeatureCollect].join(' ')}>
                    <Svg name="click-collect" aria-hidden={true} />
                    <span className={classes.footerFeatureContent}>Click & Collect</span>
                </Link>
            </li>
            <li>
                <Link
                    to="/delivery-information"
                    className={[classes.footerFeature, classes.footerFeatureDelivery].join(' ')}
                >
                    <Svg name="delivery" aria-hidden={true} />
                    <span className={classes.footerFeatureContent}>Delivery</span>
                </Link>
            </li>
            <li>
                <a
                    href="https://help.woodies.ie/knowledge"
                    className={[classes.footerFeature, classes.footerFeatureFaqs].join(' ')}
                    target="_blank"
                    rel="noreferrer"
                >
                    <Svg name="faq" aria-hidden={true} />
                    <span className={classes.footerFeatureContent}>FAQs</span>
                </a>
            </li>
        </ul>
    );
});
